import { render, staticRenderFns } from "./fee-loader.vue?vue&type=template&id=dc1e15b0"
import script from "./fee-loader.vue?vue&type=script&lang=js"
export * from "./fee-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports